<template>
  <div class="sidebar"
       :data-color="backgroundColor"
       :data-active-color="activeColor">

    <div class="sidebar-wrapper" ref="sidebarScrollArea">
        <div class="photo" :style="`background-color: ${user.userPictureBgColor || 'none'}`">
            <img :src="user.picture || 'static/img/flota-logo.png'" alt="user avatar"/>
        </div>
        <ul class="nav">
            <slot name="links">
            <sidebar-item v-for="(link, index) in sidebarLinks"
                            :key="link.name + index"
                            :link="link">

                <sidebar-item v-for="(subLink, index) in link.children"
                            :key="subLink.name + index"
                            :link="subLink">
                </sidebar-item>
            </sidebar-item>
            </slot>

        </ul>
    </div>
  </div>
</template>
<script>
  import 'perfect-scrollbar/dist/css/perfect-scrollbar.css'
  export default {
    props: {
      title: {
        type: String,
        default: 'AutoFlota',
        description: 'Sidebar title'
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar background color (white|brown|black)'
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        },
        description: 'Sidebar active text color (primary|info|success|warning|danger)'
      },
      logo: {
        type: String,
        default: 'static/img/new-logo.png',
        description: 'Sidebar Logo'
      },
      sidebarLinks: {
        type: Array,
        default: () => [],
        description: 'Sidebar links. Can be also provided as children components (sidebar-item)'
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      }
    },
    data() {
      return {
        imgBackground: 'static/img/background/flota-sidebar-bg.jpeg' //'static/img/background/Background_2x.jpg'
      }
    },
    methods: {
      async initScrollBarAsync () {
        let isWindows = navigator.platform.startsWith('Win');
        if(!isWindows) {
          return;
        }
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      }
    },
    mounted () {
      this.initScrollBarAsync()
    },
    computed: {
      user: function() { return this.$store.user.data || {} },
    },
    beforeDestroy () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style scoped>
    @media (min-width: 992px) {
        .navbar-search-form-mobile,
        .nav-mobile-menu{
        display: none;
        }
    }
    .sidebar {
      background-color: rgba(0, 0, 0, 0.4);
    }
    .sidebar .logo .simple-text .logo-img {
        border-radius: 10px !important;
        background: unset !important;
    }
    .sidebar .logo .simple-text .logo-img img {
        height: 34px !important;
    }
    .sidebar .logo a.logo-normal:hover {
        color:white;
    }
    
    .sidebar-wrapper {
        background-size: cover;
    }
    .photo {
      margin-top: 10px;
      padding: 5px;
      width: 150px;
      margin-left: auto;
      margin-right: auto;
    }

</style>
